import { Inject, Injectable } from '@angular/core';
import { IBehaviorTrackingProvider } from 'app/behavior-tracking/interfaces/behavior-tracking-provider.interface';
import { BEHAVIOR_TRACKING_PROVIDERS } from 'app/behavior-tracking/tokens/behavior-tracking.token';
import { environment } from 'environments/environment';

@Injectable()
export class BehaviorTrackerService {
    private providers = new Map<string, IBehaviorTrackingProvider>();
    private defaultProvider = environment.feature.behaviorTrackingAnalytics.defaultProvider;

    public constructor(@Inject(BEHAVIOR_TRACKING_PROVIDERS) providers: IBehaviorTrackingProvider[]) {
        for (const provider of providers) {
            this.providers.set(provider.name, provider);
        }
    }

    public capture(event: string, data?: Record<string, unknown>, providerName?: string | string[]): void {
        const targets = Array.isArray(providerName)
            ? providerName
            : [providerName || this.defaultProvider];

        for (const name of targets) {
            this.providers.get(name)?.capture(event, data);
        }
    }

    public identify(userId: string, properties?: Record<string, unknown>, providerName?: string | string[]): void {
        const targets = Array.isArray(providerName)
            ? providerName
            : [providerName || this.defaultProvider];

        for (const name of targets) {
            this.providers.get(name)?.identify?.(userId, properties);
        }
    }
}
